(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('ProfileCtrl', ['$rootScope', '$scope', '$stateParams', 'profileDetailsSet', '$state', 'profileHelper', 'profilesService', 'growlService', 'permissionService', '$q', 'possibleChannels', 'sweetAlertService', function ($rootScope, $scope, $stateParams, profileDetailsSet, $state, profileHelper, profilesService, growlService, permissionService, $q, possibleChannels, sweetAlertService) {
            $scope.profileDetailsSet = profileDetailsSet;

            $scope.profile = profileHelper.getProfile();
            $scope.possibleChannels = possibleChannels.filter((c) => c.allowed);
            $scope.allowOtherProperties = profileHelper.allowOtherProperties();
            $scope.availableChannels = profileHelper.getAvailableChannels();
            $scope.optInEdited = {};

            $scope.editing = false;

            $scope.optInPermission = permissionService.checkPermission("apis:ra");

            $scope.possibleStates = [{
                label: "Properties",
                value: "properties"
            },{
                label: "History",
                value: "history"
            },{
                label: "Devices",
                value: "devices"
            },{
                label: "Edit",
                value: "edit"
            },{
                label: "Delete",
                value: "delete"
            },{
                label: "Forget",
                value: "forget"
            }];
            $scope.setAvailableStates = function(){
                $scope.availableStates = $scope.possibleStates.filter(function(state){
                    return !$state.current.name.includes(state.value) && (state.value !== "edit" || (state.value == "edit" && $state.current.name.includes('properties'))) || state.value === "delete";
                });
            }
            $scope.setAvailableStates();

            $scope.delete = function () {
                sweetAlertService.confirmationAlert(
                    "Are you sure?",
                    "You will not be able to recover this profile",
                    "Yes, delete it!",
                    "No",
                    function (isConfirm) {
                        if (isConfirm) {
                            profilesService.deleteProfile($stateParams.pickedApiSpaceId, $scope.profile.generalProperties.properties.id.value).then(function (result) {
                                growlService.success("Profile successfully deleted");
                                $state.go('main.apiSpace.profiles.search', $stateParams);
                            }).catch(function (error) {
                                growlService.danger("Profile wasn't deleted due to: " + error.statusText);

                            });
                        }
                        else {
                            growlService.success("Profile wasn't deleted");
                        }
                    }
                );
            };

            $scope.forgetProfile = function () {
                sweetAlertService.confirmationAlert(
                    "Are you sure?",
                    "You will not be able to recover this profile",
                    "Yes, forget it!",
                    "No",
                    function (isConfirm) {
                        if (isConfirm) {
                            var id = encodeURIComponent($scope.profile.generalProperties.properties.id.value);
                            profilesService.forgetProfile($stateParams.pickedApiSpaceId, id).then(function (result) {
                                growlService.success("Profile successfully forgotten");
                                $state.go('main.apiSpace.profiles.search', $stateParams);
                            }).catch(function (error) {
                                growlService.danger("Profile wasn't forgotten due to: " + error.statusText);

                            });
                        }
                        else {
                            growlService.success("Profile wasn't forgotten");
                        }
                    }
                );
            };

            $scope.save = function(){
                $rootScope.$broadcast('profile:save');
                $scope.editing = false;
            }

            $scope.cancel = function(){
                $rootScope.$broadcast('profile:cancel');
                $scope.editing = false;
            }

            $scope.changeState = function(index){
                var state = $scope.availableStates[index].value;
                $scope.stateName = $scope.availableStates[index].label;
                if(state === "edit"){
                    $rootScope.$broadcast('profile:edit');
                    $scope.editing = true;
                }
                else if(state === "forget"){
                    $scope.forgetProfile();
                }
                else if(state === "delete"){
                    $scope.delete();
                }
                else{
                    $state.go('main.apiSpace.profile.'+state, {profileId: $stateParams.profileId}).then(function() {
                        $scope.setAvailableStates();
                    })
                }
            }
            
            $scope.stateName = $scope.possibleStates.find(function(state){
                return $state.current.name.includes(state.value);
            }).label;

            var criteria = $stateParams.criteria;
            var sorting = $stateParams.sorting;
            var pickedCriteria = $stateParams.pickedCriteria;


            $scope.switchOptIn = function(name){
                if(!!$scope.optInCopy[name].value != !!$scope.profile._optIn.properties[name].value){
                    $scope.optInEdited[name] = true;
                }
                else{
                    $scope.optInEdited[name] = false;
                }
            };

            $scope.anyEdited = function(){
                for(var i in $scope.optInEdited){
                    if($scope.optInEdited[i]){
                        return true;
                    }
                }
                return false;
            };
            if(!$scope.profile._optIn.properties){
                $scope.profile._optIn.properties = {};
            }
            for(var index in $scope.possibleChannels){
                var possibleChannel = $scope.possibleChannels[index];
                if(!$scope.profile._optIn.properties[possibleChannel.id]){
                    $scope.profile._optIn.properties[possibleChannel.id] = false;
                }
                $scope.optInCopy = angular.copy($scope.profile._optIn.properties);
            }

            $scope.saveOptIn = function(){
                var optIn = {
                    channels: []
                };

                var optOut = {
                    channels: []
                };
                
                for(var i in $scope.profile._optIn.properties){
                    if($scope.optInCopy[i].value != $scope.profile._optIn.properties[i].value){
                        if(!$scope.profile._optIn.properties[i].value){
                            optOut.channels.push(i);
                        }
                        else{
                            optIn.channels.push(i);
                        }
                    }
                }
                
                var $defer = $q.defer();
                var promise = $defer.promise;

                promise.then(function(){
                    if(optIn.channels.length){
                       return profilesService.profileOptIn($stateParams.pickedApiSpaceId, $stateParams.profileId, optIn).then(function(){
                            $scope.optInCopy = angular.copy($scope.profile._optIn.properties);
                            $scope.optInEdited = {};
                            growlService.success("Profile Opt In options updated");
                       });
                    }
                    else{
                        $scope.optInCopy = angular.copy($scope.profile._optIn.properties);
                        $scope.optInEdited = {};
                    }
                }).catch(function(error){
                    growlService.danger("Profile Opt In options  wasn't updated due to: " + error.statusText);
                });

                if(optOut.channels.length){
                    profilesService.profileOptOut($stateParams.pickedApiSpaceId, $stateParams.profileId, optOut).then(function(){
                        $defer.resolve();
                    });
                }
                else{
                    $defer.resolve();
                }
                
            };
            
            $scope.cancelOptIn = function(){
                $scope.profile._optIn.properties = angular.copy($scope.optInCopy);
                $scope.optInEdited = {};
            };

            $scope.$on('profile:save',function(event, data){
                profileHelper.setAvailableChannels();
                
            });
            
            $scope.goBack = function(){
                $state.go('main.apiSpace.profiles.search', {pickedApiSpaceId: $stateParams.pickedApiSpaceId, criteria: criteria, sorting: sorting, pickedCriteria: pickedCriteria});
            };
            
            $scope.run = function(){
                if(!$scope.profileDetailsSet){
                    $state.go('main.apiSpace.profiles.search', {pickedApiSpaceId: $stateParams.pickedApiSpaceId});
                }
                else if(!$scope.profile){
                    $state.go('main.apiSpace.profiles.search', {pickedApiSpaceId: $stateParams.pickedApiSpaceId});
                }
            };

            $scope.run();
        }]);

})(window.angular);
